/**
 * JWT (JSON Web Token) patterns:
 *
 * Detects JWT tokens which follow a specific structure:
 * - Three base64url-encoded parts separated by dots
 * - First part starts with 'eyJ' (base64url for '{"')
 * - Each part contains at least 10 characters
 * - Format: eyJ[header].[payload].[signature]
 *
 * Examples:
 * - eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c
 *
 * References:
 * - https://jwt.io/
 * - https://datatracker.ietf.org/doc/html/rfc7519
 */

export const jwtToken = /\beyJ[\w-]{10,}\.[\w-]{10,}\.[\w-]{10,}\b/;
